import React, { useState } from 'react';
import { useAppDispatch } from 'hooks/redux';
import { isEqual } from 'lodash';
import { setElementValues } from 'store/rfiSlice';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { answerValueTypes, ElementAnswer, ElementOption, elementTypes, IElementProps } from '../../types/RfiTypes';

const DropDown = (props: IElementProps) => {
  // Hooks
  const dispatch = useAppDispatch();

  // State
  const [selected, setSelected] = useState<string | null>(() => {
    return (
      props.element.answers?.find(
        (a: ElementAnswer) => a.answerValueType === "option"
      )?.value ?? null
    );
  });

  // Handler
  const handleChange = (e: DropDownListChangeEvent) => {
    setSelected(e.target.value);
    //props.element.setValues([{ value: e.target.value, answerValueType: answerValueTypes.OPTION }]);
    dispatch(
      setElementValues({
        elementId: props.element.elementId,
        values: [
          { value: e.target.value, answerValueType: answerValueTypes.OPTION },
        ],
      })
    );
  };

  // Render
  if (props.readOnly) {
    return (
      <div>
        <div className="form-group row">
          <label
            htmlFor={`ddl-${props.element.elementId}`}
            className="col-lg-3 col-form-label"
          >
            {props.element.elementType === elementTypes.SURVEY
              ? `${props.questionNumber}. `
              : ""}{" "}
            {props.element.fieldLabel}
          </label>
          <DropDownList
            id={`ddl-${props.element.elementId}`}
            data={
              props.element.options
                ? props.element.options
                    .sort(
                      (optA: ElementOption, optB: ElementOption) =>
                        optA.sequence - optB.sequence
                    )
                    .map((option: ElementOption, i: number) => {
                      return option.description;
                    })
                : []
            }
            value={selected}
            disabled
            style={{
              width: "400px",
            }}
          />
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <fieldset className="usa-fieldset-inputs usa-sans">
          <legend className="visuallyHidden">{props.element.fieldLabel}</legend>

          <label
            htmlFor={`ddl-${props.element.elementId}`}
            className="col-lg-3 col-form-label"
          >
            {props.element.elementType === elementTypes.SURVEY
              ? `${props.questionNumber}. `
              : ""}{" "}
            {props.element.fieldLabel}{" "}
            {props.overrideRequired === undefined ? (
              props.element.requiredResponse ? (
                <span className="requiredField">(required)</span>
              ) : (
                ""
              )
            ) : props.overrideRequired === true ? (
              <span className="requiredField">(required)</span>
            ) : (
              ""
            )}
          </label>

          <DropDownList
            id={`ddl-${props.element.elementId}`}
            data={
              props.element.options
                ? props.element.options
                    .sort(
                      (optA: ElementOption, optB: ElementOption) =>
                        optA.sequence - optB.sequence
                    )
                    .map((option: ElementOption, i: number) => {
                      return option.description;
                    })
                : []
            }
            value={selected}
            onChange={handleChange}
            style={{
              width: "400px",
            }}
          />
        </fieldset>
      </div>
    );
  }
};

const areEqual = (prevProps: IElementProps, nextProps: IElementProps) => {
  return (
    !prevProps.rerender &&
    isEqual(prevProps.element, nextProps.element) &&
    isEqual(prevProps.designMode, nextProps.designMode) &&
    isEqual(prevProps.readOnly, nextProps.readOnly)
  );
};

const DropDownElement = React.memo(DropDown, areEqual);

export default DropDownElement;
